const headerBg = () => {
    $(window).on('scroll', function () {
        if ($('#fv').height() < $(this).scrollTop()) {
            $('#header').removeClass('bg-transparent');
            $('#header').addClass('bg-white shadow-lg');
            $('#header-pc').removeClass('text-white');
            $('#header-pc').addClass('text-button');
            $('#header-menu-list li a').removeClass('header-underline-top');
            $('#header-menu-list li a').addClass('header-underline');
            $('#sp-menu span').removeClass('bg-white');
            $('#sp-menu span').addClass('bg-grey-sidebar');
            $('.header-logo-white').addClass('hidden');
            $('.header-logo-white').removeClass('block');
            $('.header-logo-black').addClass('block');
            $('.header-logo-black').removeClass('hidden');
        } else {
            $('#header').addClass('bg-transparent text-white');
            $('#header').removeClass('bg-white text-button shadow-lg');
            $('#header-pc').addClass('text-white');
            $('#header-pc').removeClass('text-button');
            $('#header-menu-list li a').addClass('header-underline-top');
            $('#header-menu-list li a').removeClass('header-underline');
            $('#sp-menu span').addClass('bg-white');
            $('#sp-menu span').removeClass('bg-grey-sidebar');
            $('.header-logo-white').addClass('block');
            $('.header-logo-white').removeClass('hidden');
            $('.header-logo-black').addClass('hidden');
            $('.header-logo-black').removeClass('block');
        }
    });
};

export default headerBg